import React from 'react'
import PropTypes from 'prop-types'

import { HighlightedText } from '../../../components'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import LogoAnimation from './logo.json'

import styles from './styles'
import Lottie from "lottie-react";


const decorators = [
  memoized,
]

function HomeCover(props) {
  const { baseline } = props

  function handleClickButton() {
    window.scrollTo(0, 900)
  }

  return (
    <div className="container">
      <div className="inner">
        <h1 className="baseline">
          <HighlightedText
            text={baseline}
            className="normal"
          />
        </h1>
      </div>
      <div className="pattern"><Lottie animationData={LogoAnimation}  /></div>
      {/* <video
          autoPlay
          loop
          muted
          width="100%"
          playsInline
        >
          <source
            src="/images/logos/Video-logo.mov"
            type="video/mov"
          />
        </video> */}

      <style jsx>{styles}</style>
    </div>
  )
}

HomeCover.propTypes = {
  baseline: PropTypes.string.isRequired,
}

HomeCover = chainDecorators(decorators, HomeCover)

export default HomeCover
